import { fetchData } from "../../Helpers";

export const SUBSCRIPTION_STALE_TIME = 1000 * 60 * 5.5;
export const SUBSCRIPTION_CACHE_TIME = Infinity;

export function getSubscriptionList(payload) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/subscription/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });
}

export function checkPrime() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/subscription/check-prime",
    successCallback: () => {},
    controller: controller,
  });
}

export function getSubscriptionCount() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/subscription/count",
    successCallback: () => {},
    controller: controller,
  });
}
